module.exports = __webpack_public_path__ + "static/media/facet-water-fire-icon-red.c2df6e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/facet-water-fire-icon-red.png
// module id = 1257
// module chunks = 0